import Loader from "../Loader";
import './style.css';

const HexLoader = ({ className }) => {
  return (
    <div className={`hex-loader ${className || ""}`}>
      <Loader />
    </div>
  );
};

export default HexLoader;
